import { useState } from "react";
import { useTranslation } from "react-i18next";

import { NavItem, NavLink, TabsWrap } from "@/shared/components/Tabs";
import { isObjEmpty } from "../../../shared/helpers";
import TripDetailsForm from "./TripDetailsForm";
import { TabPane } from "../TripsForm";
import { Nav, Tab } from "react-bootstrap";
import SecondaryDataTable from "./SecondaryDataTable";
import { getSecondaryTableColumns } from "..";

const TripTabs = ({
  rowData,
  type,
  fillupsData,
  setFillupsData,
  expensesData,
  setExpensesData,
  incomeData,
  setIncomeData,
  newRecordData,
  setNewRecordData,
  vehicle,
  driver,
  tripDocs,
  setTripDocs,
  firstTimeEdit,
  errors,
  userOptions,
  setUserOptions,
  tripType,
}) => {
  const { t } = useTranslation("common");
  const [activeKey, setActiveKey] = useState("1");

  const { fillupsColumns, expensesColumns, incomeColumns } =
    getSecondaryTableColumns();

  return (
    <Tab.Container
      defaultActiveKey="1"
      activeKey={activeKey}
      onSelect={(e) => setActiveKey(e)}
    >
      <TabsWrap>
        <Nav className="nav-tabs">
          <NavItem $active={activeKey == 1}>
            <NavLink eventKey="1">
              {t("trip_details")}{" "}
              {!isObjEmpty(errors) && (
                <i
                  className="fi fi-rr-triangle-warning"
                  style={{
                    color: "red",
                    position: "relative",
                    top: "2px",
                  }}
                ></i>
              )}
            </NavLink>
          </NavItem>
          {vehicle && (
            <>
              <NavItem $active={activeKey == 2}>
                <NavLink eventKey="2">{`${t("trip_fillups")} (${
                  fillupsData.length
                })`}</NavLink>
              </NavItem>
              <NavItem $active={activeKey == 3}>
                <NavLink eventKey="3">{`${t("trip_expenses")} (${
                  expensesData.length
                })`}</NavLink>
              </NavItem>
              <NavItem $active={activeKey == 4}>
                <NavLink eventKey="4">{`${t("trip_income")} (${
                  incomeData.length
                })`}</NavLink>
              </NavItem>
            </>
          )}
        </Nav>
        <Tab.Content>
          <TabPane
            $edit={type === "edit"}
            eventKey="1"
            // style={{
            //   height: `${window.innerHeight - 200}px`,
            //   overflow: "auto",
            // }}
          >
            <TripDetailsForm
              rowData={rowData}
              type={type}
              tripDocs={tripDocs}
              setTripDocs={setTripDocs}
              firstTimeEdit={firstTimeEdit}
              userOptions={userOptions}
              setUserOptions={setUserOptions}
              tripType={tripType}
              //userInfo={userInfo}
            />
          </TabPane>
          <TabPane eventKey="2" $edit={type === "edit"}>
            <SecondaryDataTable
              rows={fillupsData}
              setRows={setFillupsData}
              columns={fillupsColumns}
              heading={
                fillupsData.length > 0
                  ? t("items_recorded_during_trip", {
                      screenName: t("fillups"),
                    })
                  : t("no_items_recorded_during_trip", {
                      screenName: t("fillups"),
                    })
              }
              screenName={"fillups"}
              newRecordData={newRecordData}
              vehicle={vehicle}
              driver={driver}
              setNewRecordData={setNewRecordData}
              userOptions={userOptions}
            />
          </TabPane>
          <TabPane eventKey="3" $edit={type === "edit"}>
            <SecondaryDataTable
              rows={expensesData}
              setRows={setExpensesData}
              columns={expensesColumns}
              heading={
                expensesData.length > 0
                  ? t("items_recorded_during_trip", {
                      screenName: t("expenses_title"),
                    })
                  : t("no_items_recorded_during_trip", {
                      screenName: t("expenses_title"),
                    })
              }
              screenName={"expenses"}
              newRecordData={newRecordData}
              vehicle={vehicle}
              driver={driver}
              setNewRecordData={setNewRecordData}
              userOptions={userOptions}
            />
          </TabPane>
          <TabPane eventKey="4" $edit={type === "edit"}>
            <SecondaryDataTable
              rows={incomeData}
              setRows={setIncomeData}
              columns={incomeColumns}
              heading={
                incomeData.length > 0
                  ? t("items_recorded_during_trip", {
                      screenName: t("income"),
                    })
                  : t("no_items_recorded_during_trip", {
                      screenName: t("income"),
                    })
              }
              screenName={"income"}
              newRecordData={newRecordData}
              vehicle={vehicle}
              driver={driver}
              setNewRecordData={setNewRecordData}
              userOptions={userOptions}
            />
          </TabPane>
        </Tab.Content>
      </TabsWrap>
    </Tab.Container>
  );
};

export default TripTabs;
